import React from 'react';
import { useState } from 'react';

const FACTVIEW_BASE_URL = process.env.REACT_APP_FACTVIEW_BASE_URL || 'http://localhost:3000';
const FACTVIEW_CONNECTOR_API_KEY = process.env.REACT_APP_FACTVIEW_CONNECTOR_API_KEY || '';

async function checkFactviewUser(email) {
  if (!email) {
    return {
      ok: false,
      status: 400,
      error: 'email is required',
      code: 'MISSING_EMAIL',
    };
  }

  const response = await fetch(`${FACTVIEW_BASE_URL}/api/connector/check-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': FACTVIEW_CONNECTOR_API_KEY,
    },
    body: JSON.stringify({ email }),
  });

  const responseBody = await response.json();

  if (response.ok) {
    return {
      ok: true,
      registered: responseBody.registered,
      status: response.status,
    };
  }

  return {
    ok: false,
    status: response.status,
    error: responseBody.error,
    code: responseBody.code,
  };
}

async function runCheckFactviewUserTests() {
  const testEmails = ['admin@sirwolfski.com', 'missing@example.com', ''];
  for (const email of testEmails) {
    const result = await checkFactviewUser(email);
    console.log(`checkFactviewUser(${JSON.stringify(email)}) ->`, result);
  }
}

const TestEnvironment = () => {
  const [email, setEmail] = useState('');

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  async function postFactviewAI(impid, case_id){
        const response = await fetch("http://localhost:3000/api/importmodule/execute", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": 'b1f4c3d7a82e1f6d9a7c4f59e3810b2a5d9d23cf1e87b4a6c53a72f0e5c9d48a'
        },
        body: JSON.stringify({ impid, case_id })
        });

        const data = await response.json();
        console.log(data);
    }

  return (
    <div className="">
      <div>
        <button className="import-btn hover" onClick={()=>{postFactviewAI(1, 3035);}}>FVAI Execute</button>
      </div>
      <div>
        <p>Check Factview User Email: </p>
        <input value={email} onChange={handleChangeEmail} />
        <button className="import-btn hover" onClick={async ()=>{ console.log(await checkFactviewUser(email)); }}>Check User</button>
        <button className="import-btn hover" onClick={()=>{runCheckFactviewUserTests();}}>Run Check-User Test Suite</button>
      </div>
    </div>
  );
};

export default TestEnvironment;
